import React, { useContext } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { NotificationContext } from '../../../components/GrowlNotifications';
import { updateSuperLinkAssessmentsExpirationTime } from '../../../services/apps/SuperLinkService';
import { growlErrors, growlActionSuccess } from '../../../utils/NotificationUtil';
import SuperLinkAssessmentsExpirationUpdateForm from './SuperLinkAssessmentsExpirationUpdateForm';
import { AccountContext } from '../../../components/AccountContext';

const messages = defineMessages({
  successNoti: {
    id: 'noti.success',
    defaultMessage: 'Success!',
  },
  header: {
    id: 'superlink.assessments.expiration.update.header',
    defaultMessage: 'Update Expiration Status',
  },
});

const SuperLinkAssessmentsExpirationUpdate = ({ superLink, toggleEdit }) => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);
  const { formatMessage } = useIntl();

  const updateExpirationTime = async (formValues) => {
    const { expirationTime } = formValues;

    const expirationTimeWithNoTimeZone = new Date(
      Date.UTC(expirationTime.getFullYear(), expirationTime.getMonth(), expirationTime.getDate()),
    );

    const input = {
      accountId: currentAccount,
      superLinkId: superLink.id,
      expirationTime: expirationTimeWithNoTimeZone,
    };
    try {
      await updateSuperLinkAssessmentsExpirationTime(input);
      growlActionSuccess(growl, formatMessage(messages.successNoti));
      toggleEdit('updateExpiration');
    } catch (errors) {
      growlErrors(growl, errors);
    }
  };

  const handleCancel = () => {
    toggleEdit('updateExpiration');
    return Promise.resolve();
  };

  return <SuperLinkAssessmentsExpirationUpdateForm onSubmit={updateExpirationTime} handleCancel={handleCancel} />;
};

SuperLinkAssessmentsExpirationUpdate.propTypes = {
  toggleEdit: PropTypes.func.isRequired,
  superLink: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default SuperLinkAssessmentsExpirationUpdate;
